<script setup>
import { computed } from 'vue';
import { currency } from '../../_00_elements/number-formatter';

const props = defineProps({
  icon: {
    type: String,
    required: true,
    default: () => '',
  },
  title: {
    type: String,
    required: true,
    default: () => '',
  },
  value: {
    type: Number,
    required: true,
    default: () => 0,
  },
  percent: {
    type: Number,
    required: false,
    default: () => 0,
  },
  percentDirection: {
    type: String,
    required: false,
    default: () => '',
  },
  euros: {
    type: Boolean,
    required: false,
    default: () => false,
  },
});

const computedValue = computed(() => {
  if (props.euros) {
    return currency(props.value);
  }
  return props.value;
});
const isPercentPositive = computed(() => props.percent > 0);
</script>

<template>
  <div class="adaf-stats">
    <span class="adaf-stats__icon" :class="`adaf-stats__icon--${icon}`" />
    <div class="adaf-stats__details">
      <p class="adaf-stats-details__title">
        {{ title }}
      </p>
      <p class="adaf-stats-details__value">
        {{ computedValue }}
        <span
          v-if="percent"
          class="adaf-stats-details__percent"
          :class="isPercentPositive ? 'adaf-stats-details__percent--positive' : 'adaf-stats-details__percent--negative'"
        >
          {{ Math.abs(percent) }}%
        </span>
      </p>
    </div>
  </div>
</template>
